export const getSummary = (obj) => {
    const summary = {
        BOTH: 0,
        SALESFORCE: 0,
        SATORI: 0
    }
    obj?.forEach((relationship) => {summary[relationship.match] += 1})
    return summary
}